import React from 'react';
import { CoachingReservation } from 'coaching/containers/GetAvailableReservationsContainer';
import Row from 'components/Row';
import Text from 'components/Text';
import TextWithIcon from 'components/TextWithIcon';

type Props = {
  reservation: CoachingReservation;
  userTimezone: string;
  childName: string;
  selectedSubject?: string;
};

export default function CoachingSelfServeReservationDetails(props: Props) {
  const { reservation, userTimezone, childName, selectedSubject } = props;
  const sessionDate = reservation.startDateTime.tz(userTimezone).format('ddd, MMM D [at] LT (z)');
  const sessionDuration = reservation.endDateTime.diff(reservation.startDateTime, 'minutes');

  return (
    <Text size="small">
      <Row size="xsmall">
        <Text weight="semibold" size="medium">
          {selectedSubject
            ? `${selectedSubject} for ${childName}`
            : `Coaching session for ${childName}`}
        </Text>
      </Row>
      <TextWithIcon icon="clock">
        {sessionDate} • {sessionDuration} min
      </TextWithIcon>
    </Text>
  );
}
